<template>
    <div class="p-5 darker">

        <!-- <div class="col-md-12 d-flex justify-content-between text-right"> -->
            <h5 class="d-flex flex-grow justify-content-between  align-items-center w-100">
                <span>Integrate services with your Pluralo account.</span>
                <input type="submit" value="Save" class="btn widest ml-auto" @click="save">
            </h5>
        <!-- </div> -->


        <div class="my-4">
            Here you can connect other services to augment your experience.
        </div>

        <div class="col-md-8 mb-1">
            <div class="row">
                <div class="col-md-6 d-flex flex-row align-items-center justify-content-between">
                    <div class="row w-100">
                        <div class="col-sm-10">
                            <h2>Stripe</h2>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-md-8 mb-4">
            <div class="row">
                <div class="col-md-6">
                    <label class="full">
                        Stripe API - Publishable key
                        <input type="text" class="bg-lighter" v-model="presets.stripeApiKey_Public">
                    </label>
                </div>
            </div>
        </div>

        <div class="col-md-8 mb-4">
            <div class="row">
                <div class="col-md-6">
                    <label class="full">
                        Stripe API - Secret key
                        <input type="text" class="bg-lighter" v-model="presets.stripeApiKey_Secret">
                    </label>
                </div>
            </div>
        </div>

        <div class="col-md-8 mb-1 pt-4">
            <div class="row">
                <div class="col-md-6 d-flex justify-content-between">
                    <div class="d-flex flex-column">
                        <h2>Invoicing</h2>
                        <span class="dark bold fs-small" v-if="presets.hasInvoiceSystem == false" @click="addInvoiceObject">Integrate your invoicing software with Pluralo.</span>
                    </div>
                    <div class="d-flex flex-column" v-if="presets.hasInvoiceSystem == false">
                        <button class="btn blue" @click="activateInvoicing">Activate</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-md-8 mb-4">

            <div v-if="presets.hasInvoiceSystem && presets.hasInvoiceSystem == true">
                <div class="row">
                    <div class="col-md-6">
                        <label class="full d-flex justify-content-between w-100">
                            Enabled
                            <toggle-button class="" v-model="presets.invoiceSystem.isActive" :value="true" :sync="true" :labels="{checked: 'YES', unchecked: 'NO'}"/>
                        </label>
                    </div>
                </div>

                <div class="row mt-3">
                    <div class="col-md-6">
                        <label class="full">
                            Software
                        </label>
                        <v-select :options="invoiceSoftwares" v-model="selectedInvoiveIntegrationOption" :disabled="diabledInvoiceInputs" label="name"></v-select>
                    </div>
                </div>

                <div class="row mt-3">
                    <div class="col-md-6">
                        <label class="full">
                            Get Article URL
                            <input type="text" v-model="presets.invoiceSystem.primaveraGetArticlesURL" class="bg-lighter" :disabled="diabledInvoiceInputs">
                        </label>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-md-6">
                        <label class="full">
                            Post Invoice URL
                            <input type="text" v-model="presets.invoiceSystem.primaveraPostInvoiceURL" class="bg-lighter" :disabled="diabledInvoiceInputs">
                        </label>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-md-6">
                        <label class="full">
                            Get Invoice Credit Note URL
                            <input type="text" v-model="presets.invoiceSystem.primaveraGetInvoiceCreditNoteURL" class="bg-lighter" :disabled="diabledInvoiceInputs">
                        </label>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-md-6">
                        <label class="full">
                            Get Invoice Document URL
                            <input type="text" v-model="presets.invoiceSystem.primaveraGetInvoiceDocumentURL" class="bg-lighter" :disabled="diabledInvoiceInputs">
                        </label>
                    </div>
                </div>

            </div>

        </div>

        <div class="col-md-12 text-right">
            <input type="submit" value="Save" class="btn widest ml-auto" @click="save">
        </div>
    </div>
</template>

<script>
    import extendedVSelect from '@/extends/vue-select'
    import {mapGetters, mapActions} from 'vuex'
    import List from '@/tools/list/baseList'

    export default {
        data: function() {
            return {
                selectedInvoiveIntegrationOption: null,
                diabledInvoiceInputs: true
            }
        },
        props:[
            'presets'
        ],
        created: function () {
            if(this.presets.invoiceSystem && this.presets.invoiceSystem.invoiceSystemType){
                this.selectedInvoiveIntegrationOption = this.getInvoicingIntegrationOptions.filter(integrationOption => {
                    return integrationOption.id == this.presets.invoiceSystem.invoiceSystemType
                })[0]
            } else {
                this.selectedInvoiveIntegrationOption = this.getInvoicingIntegrationOptions[0]
            }


        },
        computed: {
            ...mapGetters([
                'getInvoicingIntegrationOptions',
                'getDefaultInvoiceSystemPreset'
            ]),
            invoiceSoftwares: function () {
                return this.getInvoicingIntegrationOptions
            }
        },
        methods:{
            ...mapActions([
                'saveSettingsPresets',
                'showUpgradePlanPopup'
            ]),
            activateInvoicing: function () {
                this.showUpgradePlanPopup(true)
            },
            addInvoiceObject: function () {
                this.presets.hasInvoiceSystem = true
                if(!this.presets.invoiceSystem){
                    this.$set(this.presets, 'invoiceSystem', this.getDefaultInvoiceSystemPreset)
                }
            },
            save: function(){
                // this.$emit('save');
                this.saveSettingsPresets(this.presets)
            }
        },
        components:{
            vSelect: extendedVSelect,
            List
        }
    }
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// TabIntegrations.vue?f7af1832